import {useState, useCallback} from "react";

// To get the localstorage store object
const getStoreFromLocalStorage = (key) => {
  try {
    const item = window.localStorage.getItem(key);
    return item && JSON.parse(item);
  } catch (error) {
    console.log(error);
  }
}

// The local storage hook
const UseLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(getStoreFromLocalStorage(key) || initialValue);

  const setValue = useCallback(
    (value) => {
      try {
        const valueToStore = value instanceof Function ? value(storedValue) : value;
        setStoredValue(valueToStore);
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
        console.warn(error);
      }
    },
    [storedValue, setStoredValue, key],
  );
  
  return [storedValue, setValue];
}

// A middleware having functionality to get, add, delete an item or 
// delete the whole store object from local storage;
const useExtendedLocalStorage = (key, initialValue) => {
  const [store, setStore] = UseLocalStorage(key, initialValue);
  
  const getItem = (item) => {
    return store[item];
  }
  
  const setValue = (itemKey, value) => {
    const updatedStore = getStoreFromLocalStorage(key);
    setStore({...updatedStore, [itemKey]: value});
  }

  const deleteItem = (item) => {
    let updatedStore = Object.assign({}, store)
    delete updatedStore[item];
    setStore(updatedStore);
  }
  
  const deleteAll = () => {
    localStorage.removeItem(key);
  }

  return {
    getItem,
    setValue,
    deleteItem,
    deleteAll,
    store
  }
}

export default useExtendedLocalStorage;